export const pluginID = 'm&mPlugin';

export const modals = {
  ADDRESS_SEARCH: 'address-search',
};

export const seniorTagID = 29;
